import { useFormContext } from '@slal/ui/react-hook-form/core';

export const useChargesCardData = () => {
    const {
        control,
        watch,
        setValue,
        formState: { errors },
    } = useFormContext();

    const [
        clientName,
        productName,
        drawdown,
        drawdownType,
        drawdownAmount,
        drawdownPercent,
        contributions,
        contributionsAmount,
    ] = watch([
        'clientName',
        'productName',
        'drawdown',
        'drawdownType',
        'drawdownAmount',
        'drawdownPercent',
        'contributions',
        'contributionsAmount',
    ]);

    const isDrawdownPercentErrorMessage = !!errors.drawdownPercent?.message;

    const isCardDisabled = [
        !clientName || !productName || !!isDrawdownPercentErrorMessage,
        productName === 'postRetirement'
            ? drawdown === undefined ||
              (drawdown === 'Yes' &&
                  (drawdownType === 'percent'
                      ? drawdownPercent === undefined || drawdownPercent > 100
                      : drawdownAmount === undefined || drawdownAmount === 0))
            : contributions === undefined ||
              (contributions === 'Yes' && (contributionsAmount === undefined || contributionsAmount === 0)),
        watch(['check1', 'check2', 'check3', 'check4', 'check5']).every(check => !check),
    ].some(Boolean);

    return {
        isCardDisabled,
        control,
        watch,
        setValue,
    };
};
